import { Grid } from '@mui/material'
import clsx from 'clsx'
import { ChangeEvent, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as Redux from 'redux'
import BaseDatePicker from '@Components/Form/BaseDatePicker/BaseDatePicker'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import UploadImage from '@Components/Form/UploadImage/UploadImage'
import { CommonService } from '@Services/common.service'
import { FormService } from '@Services/form.service'
import InputMask from 'react-input-mask'
import BaseCreatableSelect from '@Components/Form/BaseCreatableSelect/BaseCreatableSelect'
import { EAuthReground } from '../../../enum/auth.enum'
import { MCity, MCountry, MState } from '../../../models/auth.model'
import { ISelectOptions } from '../../../models/common.model'
import { IRootStates } from '../../../models/store.model'
import AuthAction from '../../../store/auth/auth.action'
import CreateProfileLayout from './CreateProfileLayout'

// select options
const genderOptions: ISelectOptions[] = [
    {
        name: 'None',
        value: '',
    },
    {
        name: 'Male',
        value: 'MALE',
    },
    {
        name: 'Female',
        value: 'FEMALE',
    },
]

const noneOption = {
    name: 'None',
    value: '',
}

const defaultValues: any = {
    address: '',
    state: '',
    country: '',
    weight: '',
    dob: null,
    firstName: '',
    middleName: '',
    lastName: '',
    city: '',
    zipCode: '',
    height: '',
    gender: '',
    securityNumber: '',
    profileImageId: '',
    profileImage: '',
}

interface ICreateProfileStep1 {
    setRegister: (registerData: any) => void
    getReground: (type: string, parentId: string) => void
    clearReground: (types: string[]) => void
    registers: any
    publicToken: string
    countries: MCountry[]
    states: MState[]
    cities: MCity[]
}

const CreateProfileStep1 = (props: ICreateProfileStep1) => {
    // core section
    const {
        setRegister,
        getReground,
        clearReground,
        registers,
        publicToken,
        countries,
        states,
        cities,
    } = props
    const ac = new AbortController()
    const history = useHistory()
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        watch,
        register,
    } = useForm({ defaultValues })
    const watchProfileImage = watch('profileImage')
    const classesInput = 'reddit-input w-100'

    // states section
    // const [imageUrl, setImageUrl] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    // hooks section
    useEffect(() => {
        if (!registers?.security) return history.push('/register')
        if (!registers?.stepOne) return
        const { state, city } = registers?.stepOne
        if (state) getReground('STATE', 'US')
        if (city) getReground('CITY', state)

        reset({ ...registers?.stepOne })
        return () => {
            ac.abort()
        }
    }, [])

    useEffect(() => {
        if (publicToken) getReground('COUNTRY', '')
    }, [publicToken])

    // functions section
    const onSubmit = (formData: any) => {
        const newData = { ...registers, stepOne: formData }
        setRegister(newData)
        history.push('/create-profile-step-2')
    }

    const onHandleSelect = (id: any, type: string) => {
        switch (type) {
            case 'COUNTRY':
                setValue('state', null)
                setValue('city', null)
                clearReground([EAuthReground.STATES, EAuthReground.CITIES])
                if (!id) return
                getReground('STATE', id)
                break
            case 'STATE':
                setValue('city', null)
                clearReground([EAuthReground.CITIES])
                if (!id) return
                getReground('CITY', id)
                break
            default:
                break
        }
    }

    const handleFileChange = (file: any) => {
        setIsLoading(true)
        CommonService.uploadImage(file, false)
            .then((response: any) => {
                // setImageUrl(response?.url)
                setValue('profileImageId', response?.id)
                setValue('profileImage', response?.url)
                setIsLoading(false)
            })
            .catch(() => {
                setIsLoading(false)
            })
    }

    // main section
    return (
        <CreateProfileLayout>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="stretch"
                    spacing={2}
                >
                    <Grid item xs={6}>
                        {/* register product image with form field manually */}
                        {/* <input
                            type="text"
                            {...register('profileImage', { required: true })}
                            hidden
                        /> */}
                        <UploadImage
                            className={clsx(
                                'w-100 mb-2',
                                errors?.profileImage && true
                                    ? 'border-danger'
                                    : ''
                            )}
                            style={{ height: 174 }}
                            fileChanged={handleFileChange}
                            imageUrl={watchProfileImage}
                            isLoading={isLoading}
                            type="upload-profile"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Controller
                            control={control}
                            name="firstName"
                            defaultValue=""
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="First Name"
                                    variant="filled"
                                    className={clsx(classesInput, 'mb-2')}
                                    error={errors?.firstName && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'firstName',
                                        'First Name'
                                    )}
                                    onKeyPress={(e: any) =>
                                        CommonService.allowsInput(e, [
                                            'alphabet',
                                            'space',
                                        ])
                                    }
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            name="middleName"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="Middle Name"
                                    variant="filled"
                                    className={clsx(classesInput, 'mb-2')}
                                    error={errors?.middleName && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'middleName',
                                        'Middle Name'
                                    )}
                                    onKeyPress={(e: any) =>
                                        CommonService.allowsInput(e, [
                                            'alphabet',
                                            'space',
                                        ])
                                    }
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            name="lastName"
                            defaultValue=""
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="Last Name"
                                    variant="filled"
                                    className={clsx(classesInput, 'mb-3')}
                                    error={errors?.lastName && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'lastName',
                                        'Last Name'
                                    )}
                                    onKeyPress={(e: any) =>
                                        CommonService.allowsInput(e, [
                                            'alphabet',
                                            'space',
                                        ])
                                    }
                                />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item sm={6} className="pt-2">
                        <Controller
                            control={control}
                            name="gender"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <BaseSelect
                                    label="Sex"
                                    options={genderOptions}
                                    value={value}
                                    onChange={onChange}
                                    fullWidth
                                    className={classesInput}
                                    error={errors?.gender && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'gender',
                                        'Sex'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={6} className="pt-2">
                        <Controller
                            control={control}
                            name="country"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <BaseCreatableSelect
                                    label="Country"
                                    options={countries}
                                    value={value}
                                    onChange={(e: any) => {
                                        onChange(e)
                                        onHandleSelect(e, 'COUNTRY')
                                    }}
                                    fullWidth
                                    className={classesInput}
                                    error={errors?.country && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'country',
                                        'Country'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={6} className="pt-2">
                        <Controller
                            control={control}
                            name="dob"
                            defaultValue={null}
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <BaseDatePicker
                                    {...field}
                                    label="Date Of Birth"
                                    value={value}
                                    onChange={(e: any) => {
                                        onChange(e)
                                    }}
                                    fullWidth
                                    className={classesInput}
                                    error={errors?.dob && true}
                                    inputRef={ref}
                                    // helperText="tests"
                                    maxDate={new Date()}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={6} className="pt-2">
                        <Controller
                            control={control}
                            name="state"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <BaseCreatableSelect
                                    label="State"
                                    options={states}
                                    value={value}
                                    onChange={(e: any) => {
                                        onChange(e)
                                        onHandleSelect(e, 'STATE')
                                    }}
                                    fullWidth
                                    className={classesInput}
                                    error={errors?.state && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'state',
                                        'State'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={6} className="pt-2">
                        <Controller
                            control={control}
                            name="weight"
                            defaultValue=""
                            rules={{ maxLength: 3 }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                // <InputMask
                                //     mask="999"
                                //     value={value}
                                //     onChange={(e: ChangeEvent<any>) => {
                                //         const validatedValue = e?.target?.value
                                //         onChange(
                                //             validatedValue?.replaceAll('_', '')
                                //         )
                                //     }}
                                //     className={classesInput}
                                // >
                                //     {(inputProps: any) => {
                                //         return (
                                <RedditTextField
                                    // {...inputProps}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="Weight"
                                    variant="filled"
                                    className={classesInput}
                                    error={errors?.weight && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'weight',
                                        'Weight',
                                        'Weight should less than or equal 3 digit'
                                    )}
                                />
                                //         )
                                //     }}
                                // </InputMask>
                            )}
                        />
                    </Grid>
                    <Grid item sm={6} className="pt-2">
                        <Controller
                            control={control}
                            name="city"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange },
                            }: any) => (
                                <BaseCreatableSelect
                                    label="City"
                                    options={cities}
                                    value={value}
                                    onChange={(e: any) => {
                                        onChange(e)
                                        onHandleSelect(e, 'CITY')
                                    }}
                                    fullWidth
                                    className={classesInput}
                                    error={errors?.city && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'city',
                                        'City'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={6} className="pt-2">
                        <Controller
                            control={control}
                            name="height"
                            defaultValue=""
                            rules={{ minLength: 3 }}
                            render={({
                                field: { ref, value, onChange },
                            }: any) => (
                                <InputMask
                                    mask="9-99"
                                    value={value}
                                    onChange={(e: ChangeEvent<any>) => {
                                        const validatedValue = e?.target?.value
                                        onChange(
                                            validatedValue?.replaceAll('_', '')
                                        )
                                    }}
                                    className={classesInput}
                                >
                                    {(inputProps: any) => {
                                        return (
                                            <RedditTextField
                                                {...inputProps}
                                                inputRef={ref}
                                                label="Height"
                                                variant="filled"
                                                error={errors?.height && true}
                                                helperText={FormService.getErrorMessage(
                                                    errors,
                                                    'height',
                                                    'Height',
                                                    'Height should be X-X or X-XX'
                                                )}
                                            />
                                        )
                                    }}
                                </InputMask>
                            )}
                        />
                    </Grid>
                    <Grid item sm={6} className="pt-2">
                        <Controller
                            control={control}
                            name="address"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    inputRef={ref}
                                    label="Address"
                                    variant="filled"
                                    className={classesInput}
                                    error={errors?.address && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'address',
                                        'Address'
                                    )}
                                    onKeyPress={(e: any) =>
                                        CommonService.allowsInput(e, [
                                            'alphabet',
                                            'space',
                                            'numeric',
                                        ])
                                    }
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={6} className="pt-2">
                        <Controller
                            control={control}
                            name="securityNumber"
                            defaultValue=""
                            rules={{ minLength: 11 }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <InputMask
                                    mask="999-99-9999"
                                    value={value}
                                    onChange={(e: ChangeEvent<any>) => {
                                        const validatedValue = e?.target?.value
                                        onChange(
                                            validatedValue?.replaceAll('_', '')
                                        )
                                    }}
                                    className={classesInput}
                                >
                                    {(inputProps: any) => {
                                        return (
                                            <RedditTextField
                                                {...inputProps}
                                                inputRef={ref}
                                                label="Social Security number"
                                                variant="filled"
                                                className={classesInput}
                                                error={
                                                    errors?.securityNumber &&
                                                    true
                                                }
                                                helperText={FormService.getErrorMessage(
                                                    errors,
                                                    'securityNumber',
                                                    'Social Security number',
                                                    'Social Security number should be XXX-XX-XXXX'
                                                )}
                                            />
                                        )
                                    }}
                                </InputMask>
                            )}
                        />
                    </Grid>
                    <Grid item sm={6} className="pt-2">
                        <Controller
                            control={control}
                            name="zipCode"
                            defaultValue=""
                            rules={{ minLength: 5 }}
                            render={({
                                field: { ref, value, onChange },
                            }: any) => (
                                <InputMask
                                    mask="99999"
                                    value={value}
                                    onChange={(e: ChangeEvent<any>) => {
                                        const validatedValue = e?.target?.value
                                        onChange(
                                            validatedValue?.replaceAll('_', '')
                                        )
                                    }}
                                    className={classesInput}
                                >
                                    {(inputProps: any) => {
                                        return (
                                            <RedditTextField
                                                {...inputProps}
                                                inputRef={ref}
                                                label="Zip Code"
                                                variant="filled"
                                                error={errors?.zipCode && true}
                                                helperText={FormService.getErrorMessage(
                                                    errors,
                                                    'zipCode',
                                                    'Zip Code',
                                                    'Zip Code should be 5 digit'
                                                )}
                                            />
                                        )
                                    }}
                                </InputMask>
                            )}
                        />
                    </Grid>
                </Grid>
                <button type="submit" className="auth-primary-btn mt-3">
                    Next
                </button>
            </form>
        </CreateProfileLayout>
    )
}

// store section
const mapStateToProps = (state: any) => {
    const { register, publicToken } = state?.auth
    const { countries, states, cities } = state?.tempAuth

    return {
        registers: register,
        publicToken,
        countries,
        states,
        cities,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { setRegister, getReground, clearReground } = AuthAction
    return {
        setRegister: (registerData: any) =>
            dispatch(setRegister(registerData) as any),
        getReground: (type: string, parentId: string) =>
            dispatch(getReground(type, parentId) as any),
        clearReground: (types: string[]) =>
            dispatch(clearReground(types) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProfileStep1)
